export default "__VITE_PUBLIC_ASSET__08814323__"